export default __webpack_public_path__ + "ae58ece.png";